module.exports = __webpack_public_path__ + "img/V3.dee578f7.png";